import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import AdminTable, { BORDER_BOTTOM, BORDER_TOP, modernTableProps, modernTableStyle } from './AdminTable';

class ActivationTable extends Component {
  static propTypes = {
    activations: PropTypes.array,
    onRevoke: PropTypes.object,
    accentColor: PropTypes.string
  }

  generateEmptyActivationRow = ({ rowStyle, style, cellStyle }) => {
    const defaultCellStyle = {
      ...cellStyle,
      borderLeft: 'inherit',
      borderRight: 'inherit',
      borderBottom: 'inherit',
    };
    return (
      <AdminTable.tr
        className="stat-table-row no-border-row"
        style={{ ...style, ...rowStyle }}
        cellStyle={cellStyle}
        key={0}>
        <AdminTable.td
          colspan='5'
          cellStyle={{ ...cellStyle, alignItems: 'center' }}
          style={defaultCellStyle}>
          <div
            style={{ height: 50, fontWeight: 'bold' }}
            className='display-flex align-items-center justify-content-center color-gray'>
            NO ACTIVATIONS FOUND
          </div>
        </AdminTable.td>
      </AdminTable.tr>
    );
  }
  generateActivationRow = ({ activation, onRevoke, accentColor, timezone, rowStyle, style, cellStyle }) => {
    const defaultCellStyle = {
      ...cellStyle,
      borderLeft: 'inherit',
      borderRight: 'inherit',
      borderBottom: 'inherit',
      lineHeight: 1.4
    };
    return (
      <AdminTable.tr
        className="stat-table-row no-border-row"
        style={{ ...style, ...rowStyle }}
        cellStyle={cellStyle}
        key={activation.id}>
        <AdminTable.td
          cellStyle={cellStyle}
          style={{ ...defaultCellStyle, borderTop: '0px solid transparent', }}>
          <span>
            {`${activation.accountUser.firstName} ${activation.accountUser.lastName}`}
          </span>
        </AdminTable.td>
        <AdminTable.td
          cellStyle={cellStyle}
          style={defaultCellStyle}>
          <span>{activation.computerName}</span>
        </AdminTable.td>
        <AdminTable.td
          cellStyle={cellStyle}
          style={defaultCellStyle}>
          <span>
            {moment.tz(activation.activateDate, timezone).format('L LT')}
          </span>
        </AdminTable.td>
        <AdminTable.td
          cellStyle={cellStyle}
          style={defaultCellStyle}>
          <span>
            {moment.tz(activation.lastLogin.useDate, timezone).format('L LT')}
          </span>
        </AdminTable.td>
        <AdminTable.td
          cellStyle={{ ...cellStyle, alignItems: 'center' }}
          style={{ ...defaultCellStyle, lineHeight: 1 }}>
        <span onClick={() => onRevoke(activation.id)} style={{ color: accentColor, fontSize: 20 }}>
        <i className="fa fa-trash-o cursor-pointer"/>
        </span>
        </AdminTable.td>
      </AdminTable.tr>
    );
  }

  render() {
    const { activations, onRevoke, accentColor } = this.props;
    const STYLE = modernTableStyle(accentColor);
    const tableProps = modernTableProps(accentColor);
    const timezone = moment.tz.guess();

    let activationRow = this.generateEmptyActivationRow({
      rowStyle: STYLE.fastStatsTable.row,
      cellStyle: STYLE.fastStatsTable.cell
    });
    if (activations && activations.length > 0) {
      activationRow = activations.map(activationRow => (
        this.generateActivationRow({
          activation: activationRow,
          rowStyle: STYLE.fastStatsTable.row,
          cellStyle: STYLE.fastStatsTable.cell,
          onRevoke,
          accentColor,
          timezone
        })
      ));
    }

    return (
      <AdminTable {...tableProps} style={{ ...tableProps.style, width: '100%' }}>
        <AdminTable.thead tableAccent={STYLE.fastStatsTable.row.tableAccent}>
          <AdminTable.tr style={BORDER_BOTTOM} cellStyle={STYLE.fastStatsTable.cell} className={'stat-table-row'}>
            <AdminTable.th
              cellStyle={STYLE.fastStatsTable.cell}
              style={{ padding: '5px 0', ...STYLE.fastStatsTable.header }}>Name</AdminTable.th>
            <AdminTable.th
              cellStyle={STYLE.fastStatsTable.cell}
              style={{ padding: '5px 0', ...STYLE.fastStatsTable.header }}>Computer Name</AdminTable.th>
            <AdminTable.th
              cellStyle={STYLE.fastStatsTable.cell}
              style={{ padding: '5px 0', ...STYLE.fastStatsTable.header }}>Activation Date</AdminTable.th>
            <AdminTable.th
              cellStyle={STYLE.fastStatsTable.cell}
              style={{ padding: '5px 0', ...STYLE.fastStatsTable.header }}>Last Login</AdminTable.th>
            <AdminTable.th
              cellStyle={STYLE.fastStatsTable.cell}
              style={{ padding: '5px 0', ...STYLE.fastStatsTable.header }}>Revoke Access</AdminTable.th>
          </AdminTable.tr>
        </AdminTable.thead>
        <AdminTable.tbody tableAccent={STYLE.fastStatsTable.row.tableAccent}>
          {activationRow}
        </AdminTable.tbody>
      </AdminTable>
    );
  }
}

export default connect()(ActivationTable);